export const routeName = 'ReclamationReportsPage'

export const route = {
  path: '/reclamation/reports',
  name: routeName,
  component: () => import('./ReclamationReportsPage.vue')
}
